export default "<div id=\"chart\">\r\n</div>"